import LineChart from "./LineChart";

export default function SalesOverView() {
  return <LineChart />;
}
